import api from './authService';

export const getProspects = async () => {
    const response = await api.get('/prospects');
    return response.data;
};

export const createProspect = async (data) => {
    const response = await api.post('/prospects', data);
    return response.data;
};

export const bulkCreateProspects = async (prospects) => {
    const response = await api.post('/prospects/bulk', { prospects });
    return response.data;
};

export const updateProspect = async (id, data) => {
    const response = await api.put(`/prospects/${id}`, data);
    return response.data;
};

export const deleteProspect = async (id) => {
    const response = await api.delete(`/prospects/${id}`);
    return response.data;
};

export const logProspectAction = async (id, data) => {
    const response = await api.post(`/prospects/${id}/actions`, data);
    return response.data;
};

export const deleteProspectAction = async (id, actionId) => {
    const response = await api.delete(`/prospects/${id}/actions/${actionId}`);
    return response.data;
};
